import React, { Component } from 'react'
import { connect } from 'react-redux'
import autobind from 'autobind-decorator'

import TSelectForm from "../../common/TSelectForm"
import Timezone from './Timezone'

import * as SaveStatus from '../../../constants/SaveStatus'
import { receiveEtc } from '../../../actions/setting/blog'
import { jsonResponseHandler } from "../../../utils/FetchHelper"
import TSubmitButtonForm from "../../common/TSubmitButtonForm";
import {addPrefix} from "../../../utils/UriUtil";

@connect(state => ({
	etc: state.setting.blog.etc
}), dispatch => ({
	handleReceiveEtc(etc) {
		dispatch(receiveEtc(etc))
	},
    dispatch
}))
class BlogEtcForm extends Component {

	constructor(props) {
		super(props)
		this.state = Object.assign({
			saveStatus: SaveStatus.READY
		}, props.etc)
	}

	@autobind
	handleChangePublishWholeOnRSS(item) {
		this.setState({
			publishWholeOnRSS: item.value
		})
	}

	@autobind
	handleChangeEntriesOnRSS(item) {
		this.setState({
			entriesOnRSS: item.value
		})
	}

	@autobind
	handleChangeTimezone(item) {
		this.setState({
			timezone: item.value
		})
	}

	@autobind
	handleSubmit(e) {
		e.preventDefault()

		const {publishWholeOnRSS, entriesOnRSS, hideMenubar, timezone, saveStatus} = this.state
		const {handleReceiveEtc, dispatch} = this.props

		if (saveStatus === SaveStatus.DOING) {
			return
		}

		const etc = {
			publishWholeOnRSS, entriesOnRSS, hideMenubar, timezone
		}

		this.setState({
			saveStatus: SaveStatus.DOING
		})
		fetch(addPrefix("/manage/setting/blog/etc.json"), {
			method: 'post',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(etc)
		})
			.then(jsonResponseHandler(dispatch))
			.then(() => {
				this.setState({
					saveStatus: SaveStatus.DONE
				})
				handleReceiveEtc(etc)
			})
			.catch(e => {
				console.error(e)
				this.setState({
					saveStatus: saveStatus
				})
			})
	}

	isChangedAndValid() {
		const { publishWholeOnRSS, entriesOnRSS, hideMenubar, timezone } = this.state
		const { etc } = this.props

		return publishWholeOnRSS !== etc.publishWholeOnRSS || entriesOnRSS !== etc.entriesOnRSS || hideMenubar !== etc.hideMenubar || timezone !== etc.timezone
	}

	render() {
		const { publishWholeOnRSS, entriesOnRSS, timezone, saveStatus } = this.state

		let needSave = this.isChangedAndValid()
		let status = saveStatus
		if (saveStatus !== SaveStatus.DOING && needSave) {
			status = SaveStatus.CAN_SUBMIT
		}

		return (
			<form className="wrap_set" onSubmit={this.handleSubmit}>
				<fieldset>
					<legend className="screen_out">RSS, 표시시간 설정</legend>
					<div className="item_set">
						RSS는

						<TSelectForm name="publishWholeOnRSS" className="opt_set opt_blog2" items={[
							{ label:'부분 공개', value:'0' },
							{ label:'전체 공개', value:'1' },
						]} selected={publishWholeOnRSS} onSelect={this.handleChangePublishWholeOnRSS}/>

						로 설정하며, 공개될 RSS를

						<TSelectForm name="entriesOnRSS" className="opt_set opt_blog3" items={[
							{ label:'5', value:'5' },
							{ label:'10', value:'10' },
							{ label:'15', value:'15' },
							{ label:'20', value:'20' },
							{ label:'25', value:'25' },
							{ label:'30', value:'30' },
							{ label:'35', value:'35' },
							{ label:'40', value:'40' },
							{ label:'45', value:'45' },
							{ label:'50', value:'50' }
						]} selected={entriesOnRSS} onSelect={this.handleChangeEntriesOnRSS}/>

						개로 갱신합니다.
					</div>
					<div className="item_set">
						표시 시간은

						<TSelectForm name="timezone" className="opt_set opt_blog4" items={Timezone.map(item => ({ label:item, value:item }))}
									 selected={timezone} onSelect={this.handleChangeTimezone}/>

						(을)를 기준으로 설정합니다.
					</div>
				</fieldset>
				<fieldset>
					<legend className="screen_out">저장 버튼</legend>
					<TSubmitButtonForm type="submit" status={status} />
				</fieldset>
			</form>
		)
	}
}

export default BlogEtcForm
